import { Placement, useFloating } from '@floating-ui/react';
import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import TooltipContent from './content';

interface PortalContentProps {
    visible: boolean;
    content: ReactNode;
    placement: Placement;
    floatingStyles: React.CSSProperties;
    refs: ReturnType<typeof useFloating>['refs'];
    container?: Element | null;
    type?: 'list' | 'text';
}

const TooltipContentContainer = ({
    visible,
    content,
    placement,
    floatingStyles,
    refs,
    container,
    type = 'text',
}: PortalContentProps) => {
    if (!visible) {
        return null;
    }

    const node = (
        <div
            ref={refs.setFloating}
            style={{ ...floatingStyles }}
            className="pointer-events-none z-[10002]"
        >
            <TooltipContent
                type={type}
                content={content}
                position={placement}
            />
        </div>
    );

    return !container ? createPortal(node, document.body) : node;
};

export default TooltipContentContainer;
